import React, { memo, useState } from 'react';
import classname from 'classnames';
import { template } from '@iyunbao/cr-engine';

import { BaseWidgetProps, ActionProps } from '../utils/type';

export interface PanelProps extends BaseWidgetProps {
  label?: string;
  subLabel?: string;
  more?: {
    label?: string;
    action?: ActionProps;
  };
  description?: string;
  theme?: string;
  toggle?: boolean;
  className?: string;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  children: any;
}

const UPanel = (props: PanelProps) => {
  const [hide, setHide] = useState(false);
  const { prefixCls = 'crm-panel', children, labelStyle, label, subLabel, more, description, className, style, toggle, theme, _crengine } = props;

  const cls = classname(prefixCls, className, {
    [`${prefixCls}-theme-${theme}`]: theme,
  });

  const onAction = (action?: ActionProps) => {
    const { action: waction } = _crengine || {};

    if (action && waction) {
      waction(action);
    }
  };

  const labelNode = typeof label === 'string' ? template(label) : label;

  const descNode = () => {
    if (toggle) {
      return (
        <div
          className={classname(`${prefixCls}-toggle`, {
            [`${prefixCls}-toggle-hidden`]: hide,
          })}
        >
          <span onClick={() => setHide(!hide)}>{hide ? '展开' : '收起'}</span>
        </div>
      );
    }

    const desc = description || more?.label;

    if (desc) {
      return (
        <div className={`${prefixCls}-more`} style={labelStyle} onClick={() => onAction(more?.action)}>
          {template(desc)}
        </div>
      );
    }

    return null;
  };

  return (
    <div className={cls} style={style}>
      <div className={`${prefixCls}-title`}>
        {!!labelNode && <div className={`${prefixCls}-label`}>{labelNode}</div>}
        {!!subLabel && <div className={`${prefixCls}-subLabel`}>{subLabel}</div>}
        {descNode()}
      </div>
      <div
        className={classname(`${prefixCls}-body`, {
          [`${prefixCls}-body-hidden`]: hide,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default memo(UPanel);
